import React, { useState, useEffect, memo } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { makeStyles } from '@material-ui/core/styles';
import Box from '@material-ui/core/Box';
import SingleTimePicker from './SingleTimePicker';
import Typography from '../Typography/CustomTypography';

import styles from '../../assets/jss/components/datePickerStyle';

const useStyles = makeStyles(styles);

const areEqual = (prevProps, nextProps) => (
    prevProps.defaultValue === nextProps.defaultValue
    && prevProps.error === nextProps.error
    && prevProps.defaultStartTime === nextProps.defaultStartTime
    && prevProps.defaultEndTime === nextProps.defaultEndTime
    && prevProps.helperTexts === nextProps.helperTexts
);

const TimeRanger = memo((props) => {
    const {
        defaultStartTime,
        defaultEndTime,
        onChangeStartTime,
        onChangeEndTime,
        error,
        helperTexts,
        disabled,
    } = props;
    const classes = useStyles(props);
    const [localError, setLocalError] = useState({
        invalidStartTime: false,
        invalidEndTime: false,
        rangerTime: false,
    });
    const [helperTextLocal, setHelperTextLocal] = useState({
        startTime: '',
        endTime: '',
        rangerTime: '',
    });

    useEffect(() => {
        if (!_.isEmpty(error)) {
            setLocalError({
                invalidStartTime: error.startTime,
                invalidEndTime: error.endTime,
                rangerTime: error.rangerTime,
            });
        }
    }, [error]);

    useEffect(() => {
        if (!_.isEmpty(helperTexts)) {
            setHelperTextLocal({
                startTime: helperTexts.startTime,
                endTime: helperTexts.endTime,
                rangerTime: helperTexts.rangerTime,
            });
        }
    }, [helperTexts]);

    const handleChangeStartTime = (startTime) => {
        onChangeStartTime(startTime);
    };

    const handleChangeEndTime = (endTime) => {
        onChangeEndTime(endTime);
    };

    return (
        <>
            <Box display="flex" alignItems="baseline" flexWrap="wrap" className={classes.wrapperPicker}>
                <SingleTimePicker
                    error={localError.invalidStartTime || error.rangerTime}
                    helperText={helperTextLocal.startTime}
                    onChange={(startTime) => handleChangeStartTime(startTime)}
                    defaultValue={defaultStartTime}
                    disabled={disabled}
                />
                <span className={classes.tilde}>〜</span>
                <SingleTimePicker
                    error={localError.invalidEndTime || error.rangerTime}
                    helperText={helperTextLocal.endTime}
                    onChange={(endTime) => handleChangeEndTime(endTime)}
                    defaultValue={defaultEndTime}
                    disabled={disabled}
                />
            </Box>
            {error.rangerTime && !localError.invalidStartTime && !localError.invalidEndTime
            && <Typography color="danger" className={classes.error_text}>{helperTextLocal.rangerTime}</Typography>}
        </>
    );
}, areEqual);

TimeRanger.defaultProps = {
    defaultStartTime: '0:0',
    defaultEndTime: '0:0',
    error: {},
    helperTexts: {},
    disabled: false,
};

TimeRanger.propTypes = {
    defaultStartTime: PropTypes.string,
    defaultEndTime: PropTypes.string,
    onChangeStartTime: PropTypes.func.isRequired,
    onChangeEndTime: PropTypes.func.isRequired,
    error: PropTypes.oneOfType([() => null, PropTypes.object]),
    helperTexts: PropTypes.oneOfType([() => null, PropTypes.object]),
    disabled: PropTypes.bool,
};

const mapStateToProps = (state) => ({
    locale: state.locale.lang.current,
});

const mapDispatchToProps = () => ({});

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(TimeRanger);
